/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentTemplateRequest} from '@cash-web/protos/squareup/cash/paymenttemplate/v1/payment_template.pb'
import {GetPaymentTemplateResponse} from '@cash-web/protos/squareup/cash/paymenttemplate/v1/payment_template.pb'


export const getPaymentTemplate = (request: GetPaymentTemplateRequest, options?: CashRequestOptions) => post<GetPaymentTemplateRequest, GetPaymentTemplateResponse>("/cash-app/paymenttemplate/get-payment-template", request, {...options, rejectOnError: true })